import React, { FC } from 'react';
import { useViewport } from '../../hooks/useViewport';
import { OneColumnLayout } from '../../components/layouts';
import { MobileDomain } from './MobileDomain/MobileDomain';
import { Domain } from './Domain/Domain';

export interface DomainWrapperProps {}

export const DomainWrapper: FC<DomainWrapperProps> = () => {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <OneColumnLayout content={<MobileDomain />} />;
  }

  return <Domain />;
};
